import { render, staticRenderFns } from "./OrderSendEmailAction.vue?vue&type=template&id=c5082cfe&scoped=true&"
import script from "./OrderSendEmailAction.vue?vue&type=script&lang=js&"
export * from "./OrderSendEmailAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5082cfe",
  null
  
)

export default component.exports